import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SbSelectContext } from '@models/sb-select-context';
import { SbDataService, SbEvent, SbEventBusService } from '@services';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';
import { LocalStorageService } from '../../../shared/services/local-storage.service';

@Component({
    selector: 'app-sb-select',
    templateUrl: './sb-select.component.html',
    styleUrls: ['./sb-select.component.scss']
})
export class SbSelectComponent extends BaseWidgetComponent implements OnInit {
    @Input() context: SbSelectContext;
    dataOptions: any[];
    selectedOption: any;

    constructor(
        sbDataService: SbDataService,
        localStorageService: LocalStorageService,
        eventBus: SbEventBusService,
        activatedRoute: ActivatedRoute
    ) {
        super(sbDataService, localStorageService, eventBus, activatedRoute);
        this.responseHandler = this.setData;
    }

    ngOnInit(): void {
        super.ngOnInit();
    }

    private setData(responseData: any) {
        if (!responseData || !Array.isArray(responseData)) {
            return;
        }

        this.dataOptions = responseData
            .sort((a, b) =>
                a[this.context.labelField].localeCompare(b[this.context.labelField])
            )
            // Add "value" property needed when comparing options by the select component.
            .map((rd) => Object.assign({ value: rd[this.context.valueField] }, rd));

        // Set possible initial selected values.
        if (this.hasStateFromPreviousSelects()) {
            const payloadValue = this.eventBus.getLastEvent(this.context.topic).payload
                ?.value;
            if (payloadValue?.hasOwnProperty(this.context.valueField)) {
                this.selectedOption = Object.assign({
                    value: payloadValue[this.context.valueField],
                    payloadValue
                });
            } else {
                this.selectedOption = payloadValue;
            }
        }
    }

    getOptionLabel(option: any) {
        return option[this.context.labelField];
    }

    compareObjects(o1: any, o2: any) {
        // When no item is selected, o2 will be undefined.
        if (!o2) {
            return false;
        }
        if (o1.value === o2.value) {
            return true;
        }
        return false;
    }

    /**
     * If the "same" component has been loaded and used before. Or if some other component would have sent the same topics
     * as this one is configured to do we'll check for previous state.
     * @returns true if an event (with a payload) has been emitted before. Else false.
     */
    private hasStateFromPreviousSelects(): boolean {
        const lastEvent = this.eventBus.getLastEvent(this.context.topic);
        if (lastEvent && lastEvent.payload) {
            return true;
        }
        return false;
    }

    onChange(event) {
        const emitEvent: SbEvent = {
            source: this.context.source,
            topic: this.context.topic,
            payload: {
                // event.value is the option data (as set as value in html)
                value: event.value
            }
        };
        this.eventBus.emit(emitEvent);
    }
}
